import rp from '@reporting/rp-app-host';
import { FormAdapter, FormAlert, FormContainerOptions, FormControlType, FormValues } from '@omegagrid/form';
import { msg } from "@omegagrid/localize";
import { StatementDefinition } from "@reporting/rp-types/definition";

export class FinReportFormAdapter extends FormAdapter {

	constructor(
		private statement: StatementDefinition = null
	) { super() }

	private formFields = ['statement', 'remark', 'default_value', 'ord_num', 'number_dec', 'empty_rows', 'nulls_to_zeros', 'disabled', 'report_condition'] as const;

	getColumns() {
		return [
			{width: 180},
			{width: null},
		];
	}

	async getControls() {
		return [
			{row: 0, col: 0, type: FormControlType.Label, value: msg('Name'), for: 'statement'},
			{row: 0, col: 1, type: FormControlType.TextInput, key: 'statement', value: this.statement?.statement || null, required: true},
			{row: 1, col: 0, type: FormControlType.Label, value: msg('Remark'), for: 'remark'},
			{row: 1, col: 1, type: FormControlType.TextInput, key: 'remark', value: this.statement?.remark || null},
			{row: 2, col: 0, type: FormControlType.Label, value: msg('Indicator'), for: 'default_value'},
			{row: 2, col: 1, type: FormControlType.List, key: 'default_value', value: this.statement?.default_value || 'PS', required: true, content: {
				sourceData: [
					{ k: 'PS', v: msg('Opening balance') },
					{ k: 'MD', v: msg('Debit') },
					{ k: 'D', v: msg('Credit') },
					{ k: 'O', v: msg('Turnover') },
					{ k: 'KS', v: msg('Closing balance') }
				],
				options: {selectMode: 'single', autoClose: true}
			}},
			{row: 3, col: 0, type: FormControlType.Label, value: msg('Order'), for: 'ord_num'},
			{row: 3, col: 1, type: FormControlType.NumericInput, key: 'ord_num', value: this.statement?.ord_num || null},
			{row: 4, col: 0, type: FormControlType.Label, value: msg('Decimal digit count'), for: 'number_dec'},
			{row: 4, col: 1, type: FormControlType.NumericInput, key: 'number_dec', value: this.statement?.number_dec || null},
			{row: 5, col: 0, type: FormControlType.Label, value: msg('Show empty rows'), for: 'empty_rows'},
			{row: 5, col: 1, type: FormControlType.Checkbox, key: 'empty_rows', value: this.statement?.empty_rows || false},
			{row: 6, col: 0, type: FormControlType.Label, value: msg('Show zeros'), for: 'nulls_to_zeros'},
			{row: 6, col: 1, type: FormControlType.Checkbox, key: 'nulls_to_zeros', value: this.statement?.nulls_to_zeros || false},
			{row: 7, col: 0, type: FormControlType.Label, value: msg('Disable recalculation'), for: 'disabled'},
			{row: 7, col: 1, type: FormControlType.Checkbox, key: 'disabled', value: this.statement?.disabled || false},
			{row: 8, col: 0, type: FormControlType.Label, value: msg('Condition'), for: 'report_condition'},
			{row: 8, col: 1, type: FormControlType.TextInput, key: 'report_condition', value: this.statement?.report_condition || null},
		];
	}

	getOptions(): FormContainerOptions {
		return {
			caption: null,
			buttonsPosition: 'bottom',
			alertsPosition: 'bottom',
			buttons: ["save", "close"]
		};
	}

	async save(values: Map<string|number, FormValues>): Promise<boolean|FormAlert[]> {
		const formValues = values.get(0);
		const statement: StatementDefinition = {
			...Object.fromEntries(this.formFields.map(key => [key, formValues[key]]))
		};
		if (this.statement) statement.id_statement = this.statement.id_statement;
		await rp.ms('definition').post('statements', statement);
		return true;
	}

};
